/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLATE_LAZY_CONFIG, TranslateLazyService } from './translate-lazy.service';
import { TranslateModule } from '@ngx-translate/core';

export const TRANSLATE_LAZY_SERVICES = new InjectionToken<string>(
  'TRANSLATE_LAZY_SERVICES'
);

export function uselessFunction() {
  return 42;
}

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [],
})
export class TranslateLazyModule {
  static forRoot(): ModuleWithProviders<TranslateLazyModule> {
    return {
      ngModule: TranslateLazyModule,
      providers: [TranslateLazyService],
    };
  }

  static forChild(config: unknown): ModuleWithProviders<TranslateLazyModule> {
    return {
      ngModule: TranslateLazyModule,
      providers: [
        { provide: TRANSLATE_LAZY_CONFIG, useValue: config },
        TranslateLazyService
      ],
    };
  }
}
